import {QueryKey, useQuery, UseQueryResult, UseQueryOptions} from '@tanstack/react-query';
import {AxiosRequestConfig} from 'axios';
import {METHOD_WITH_REQUEST_BODY} from 'src/js/common/constants';
import {ApiClient} from 'src/js/common/utils/api_client';
import {QueryClientContext} from 'src/js/common/utils/query_client';

export type UseApiQueryOptions<TQueryFnData = unknown, TError = unknown, TData = unknown, TQueryKey extends QueryKey = QueryKey> = {
  axiosConfig?: AxiosRequestConfig<TData>;
  reactQueryOptions?: UseQueryOptions<TQueryFnData, TError, TData, TQueryKey>;
};

export function useApiQuery<TData = unknown, TError = unknown, TQueryKey extends QueryKey = QueryKey, TQueryFnData = unknown>(
  key: TQueryKey,
  data?: TData | null,
  options?: UseApiQueryOptions<TQueryFnData, TError, TData, TQueryKey>,
  isAuthorized?: boolean
): UseQueryResult<TData, TError> {
  return useQuery<TQueryFnData, TError, TData, TQueryKey>(
    key,
    () => {
      try {
        const isDataRequired = options?.axiosConfig?.method
          ? METHOD_WITH_REQUEST_BODY.some((item) => item === options.axiosConfig?.method)
          : false;
        const clientConfig = {
          ...options?.axiosConfig,
          url: options?.axiosConfig?.url || (typeof key === 'string' ? key : undefined),
          ...(isDataRequired ? {data: options?.axiosConfig?.data || data} : {data: undefined}),
        };
        return ApiClient.getData(clientConfig, isAuthorized);
      } catch (e) {
        console.log(e);
        return Promise.reject(e);
      }
    },
    {context: QueryClientContext, ...options?.reactQueryOptions}
  );
}
